export default {"src":"/_next/static/media/placeholder-1.20559341.svg","height":190,"width":352};